import React from 'react';
import styled from 'styled-components';

const SocialFloatingLink = styled.a`
  position: fixed;
  bottom: ${props => props.$bottom || '2rem'};
  right: ${props => props.$right || '2rem'};
  width: var(--floating-action-size, 48px);
  height: var(--floating-action-size, 48px);
  background: ${props => props.$background || 'transparent'};
  color: ${props => props.$textColor || 'white'}; /* Default to white for better contrast with gradients */
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.55rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  z-index: ${props => props.$zIndex || '1000'};
  overflow: hidden;
  white-space: nowrap;
  text-decoration: none;

  .icon, span {
    color: ${props => props.$textColor || 'white'}; /* Ensure icon and text inherit or explicitly set color */
  }

  svg {
    transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  }

  span {
    opacity: 0;
    width: 0;
    transition: all 0.3s ease;
    font-size: 1rem;
    font-weight: bold;
    margin-left: 0;
    white-space: nowrap;
  }

  &:hover {
    width: 140px;
    transform: translateY(-5px) scale(1.05);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
    color: ${props => props.$textColor || 'white'};
    text-decoration: none;
  }

  &:hover svg {
    transform: rotate(360deg) scale(1.1);
  }

  &:hover span {
    opacity: 1;
    width: auto;
    margin-left: 0.5rem;
  }

  @media (max-width: 768px) {
    width: var(--floating-action-size, 44px);
    height: var(--floating-action-size, 44px);
    font-size: 1.4rem;

    &:hover {
      width: var(--floating-action-size, 44px);
      transform: translateY(-2px) scale(1.02);
    }

    span {
      display: none;
    }
  }
`;

const SocialFloatingButton = ({ href, icon: IconComponent, text, bottom, right, background, textColor, zIndex, ariaLabel, openInNewTab = true }) => {
  return (
    <SocialFloatingLink
      href={href}
      target={openInNewTab ? "_blank" : "_self"}
      rel={openInNewTab ? "noopener noreferrer" : ""}
      $bottom={bottom}
      $right={right}
      $background={background}
      $textColor={textColor}
      $zIndex={zIndex}
      aria-label={ariaLabel}
    >
      {IconComponent && <IconComponent />}
      <span>{text}</span>
    </SocialFloatingLink>
  );
};

export default SocialFloatingButton;
